import {
  CancelDialogActions,
  ImageCancelDialogLayout,
  CancelModal,
  CancelDialogMessageLayout,
} from '@Components/shared/dialogs/CancelDialog';
import { useCampaignDrawer } from '@Modal/hooks/campaigns/useCampaignDrawer';
import { useDispatch } from 'react-redux';

export const SetupCampaignDrawerCancelDialog: React.FC = () => {
  const dispatch = useDispatch();
  const { showCancelCampaignDrawer, setShowCancelCampaignDrawer, handleCancelChanges } =
    useCampaignDrawer();

  return (
    <>
      {showCancelCampaignDrawer && (
        <CancelModal open={showCancelCampaignDrawer}>
          <ImageCancelDialogLayout
            title="Cancel campaign changes?"
            actions={
              <CancelDialogActions
                onReject={() => dispatch(setShowCancelCampaignDrawer(false))}
                onConfirm={handleCancelChanges}
              />
            }
          >
            <CancelDialogMessageLayout>
              You are about to delete all the changes you have made in campaign settings
            </CancelDialogMessageLayout>
          </ImageCancelDialogLayout>
        </CancelModal>
      )}
    </>
  );
};
